module.exports = __webpack_public_path__ + "img/6.030325c7.png";